import * as classes from "./modal-manager.module.scss";

import { useCallback, useContext, useEffect } from "react";
import { ActionType, AppContext, ModalType } from "../../contexts/AppContext";
import PlantModal from "../PlantModal/PlantModal";
import BiomeMasterModal from "../PlantModal/BiomeMasterModal";
import LookViewer from "../LookViewer/LookViewer";
import Button from "../Button/Button";
import classNames from "classnames";
import Manifesto from "../Manifesto/Manifesto";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const ModalManager = () => {
  const { state, dispatch } = useContext(AppContext);
  const { modal } = state;

  const close = useCallback(() => {
    dispatch({ type: ActionType.SetModal, value: null });
  }, [dispatch]);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" || e.key === " ") {
        close();
      }
    };

    if (modal) {
      window.addEventListener("keydown", onKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [modal]);

  return (
    <div
      className={classNames(classes.root, {
        [classes["root--visible"]]: !!modal,
      })}
    >
      <div
        className={classNames(classes.shim, {
          [classes["shim--visible"]]:
            !!modal && modal.type !== ModalType.Manifesto,
        })}
        onClick={!!modal ? close : null}
        tabIndex={-1}
      ></div>
      <TransitionGroup component={null}>
        {modal && modal.type === ModalType.Plant ? (
          <CSSTransition key={modal.name} timeout={666}>
            <div className={classes["plant-modal-transition"]}>
              <PlantModal name={modal.name} />
              <Button
                className={classes.close}
                type="button"
                label="Close"
                onClick={close}
              />
            </div>
          </CSSTransition>
        ) : null}
        {modal && modal.type === ModalType.BiomeMaster ? (
          <CSSTransition key="biome" timeout={1333}>
            <div
              className={classNames(
                classes["plant-modal-transition"],
                classes["plant-modal-transition--biome"]
              )}
            >
              <BiomeMasterModal />
              <Button
                className={classes.close}
                type="button"
                label="Close"
                onClick={close}
              />
            </div>
          </CSSTransition>
        ) : null}
        {modal && modal.type === ModalType.Look ? (
          <CSSTransition key={modal.name} timeout={0}>
            <LookViewer name={modal.name} />
          </CSSTransition>
        ) : null}
        {modal && modal.type === ModalType.Manifesto ? (
          <CSSTransition key={modal.name} timeout={0}>
            <Manifesto />
          </CSSTransition>
        ) : null}
      </TransitionGroup>
    </div>
  );
};

export default ModalManager;
